/**
 * @file delivery-details-card.tsx
 * @module app/modules/orders-delivery/components/order-details/delivery-details-card
 * @description Displays the delivery details of an order, including shop name, phone number, delivery address, and district & city.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 2.1.1
 * @version 2.1.2
 */

import { Card, Col } from "react-bootstrap";
import { OrderDetails } from "../../types/order-details";
import OrderInfoRow from "./order-info-row";

interface DeliveryDetailsCardProps {
  details: OrderDetails;
}

const DeliveryDetailsCard = ({ details }: DeliveryDetailsCardProps) => {
  return (
    <Col md={6}>
      <Card className="od-card">
        <Card.Header>
          <Card.Title>Delivery details</Card.Title>
        </Card.Header>
        <Card.Body>
          <dl className="od-info-list">
            <OrderInfoRow label="Shop name">{details.address.name}</OrderInfoRow>
            <OrderInfoRow label="Phone number">
              {details.address.phoneCountry} {details.address.phone}
            </OrderInfoRow>
            <OrderInfoRow label="Delivery address">
              {details.address.addressLine1} {details.address.landmark ? details.address.landmark : ""} - {details.address.ward}
            </OrderInfoRow>
            <OrderInfoRow label="District & city">
              {details.address.districtName}, {details.address.city}
            </OrderInfoRow>
          </dl>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DeliveryDetailsCard;
